import React, { useEffect, useCallback } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import styles from './coupons.module.scss';

import {
  Header,
  Paper,
  WithSpinner,
  HeaderActions,
  ButtonDownload,
  Title,
} from '../../components';
import CouponForm from './coupons.form';

import { actions } from '../../state';
import { config } from '../../api/config';
import { formatFilename } from '../../utils';

const CouponDetails = ({
  dispatch,
  match: { params },
  history,
  coupons: { selectedCoupon, loading, couponExport },
  xlsLoading,
  user,
}) => {
  const fetchCoupon = useCallback(
    id => {
      dispatch(actions.coupons.getCouponAction(id));
    },
    [dispatch]
  );

  useEffect(() => {
    fetchCoupon(params.id);
  }, [fetchCoupon, params.id]);

  useEffect(() => {
    dispatch(actions.coupons.setExportIdentifierAction({}));
  }, []);

  const onSubmitCoupon = payload => {
    dispatch(actions.coupons.editCouponAction(params.id, payload, history));
  };

  const xlsExport = () => {
    const filename = formatFilename(config.PAGES.coupons);
    dispatch(
      actions.coupons.exportCouponsCodeByCodeAction(params.id, filename)
    );
  };

  return (
    <section>
      <Header>
        <Title>{config.PAGES.editCoupon}</Title>
        <HeaderActions>
          <ButtonDownload onClick={xlsExport} loading={!!xlsLoading} />
        </HeaderActions>
      </Header>

      <Paper size="sm">
        <WithSpinner loading={loading}>
          {!!Object.keys(selectedCoupon) && (
            <CouponForm
              onSubmitCoupon={onSubmitCoupon}
              defaultValues={selectedCoupon}
            />
          )}
        </WithSpinner>
      </Paper>
    </section>
  );
};

const mapStateToProps = state => ({
  coupons: state.coupons,
  xlsLoading: state.download.xlsLoading,
  user: state.auth.user,
});

CouponDetails.propTypes = {
  dispatch: PropTypes.func.isRequired,
  match: PropTypes.shape({
    params: PropTypes.shape({
      id: PropTypes.string.isRequired,
    }).isRequired,
  }).isRequired,
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
  }).isRequired,
  coupons: PropTypes.shape({
    loading: PropTypes.bool.isRequired,
    selectedCoupon: PropTypes.object.isRequired,
    couponExport: PropTypes.shape({
      id: PropTypes.string,
      filename: PropTypes.string,
    }).isRequired,
  }).isRequired,
  xlsLoading: PropTypes.bool.isRequired,
  user: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  }).isRequired,
};

export default connect(mapStateToProps)(CouponDetails);
